import { render, staticRenderFns } from "./DialogItemDetails.vue?vue&type=template&id=4d45add9"
import script from "./DialogItemDetails.vue?vue&type=script&lang=js"
export * from "./DialogItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports